import { BRAND, CONTACT } from "../../data/content";
import { Instagram, Linkedin, Music2, Link2, FileText, ArrowUpRight } from "lucide-react";

const ICON_FOR = (label) => {
  const l = label.toLowerCase();
  if (l.includes("instagram")) return Instagram;
  if (l.includes("linkedin")) return Linkedin;
  if (l.includes("beatstars")) return Music2;
  if (l.includes("linktree")) return Link2;
  if (l.includes("epk")) return FileText;
  return ArrowUpRight;
};

export const Footer = () => (
  <footer className="relative bg-black border-t border-white/10 pt-16 pb-8 overflow-hidden" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12">
        <div>
          <p className="font-display text-sm uppercase tracking-[0.3em] text-[#BAF173] mb-2">{BRAND.tagline}</p>
          <p className="text-white/50 text-sm max-w-sm">{BRAND.realName} — {BRAND.origin}. Hybrid Performance Culture.</p>
        </div>
        <div className="flex flex-wrap gap-2.5">
          {CONTACT.links.map((l) => {
            const Icon = ICON_FOR(l.label);
            return (
              <a
                key={l.label}
                href={l.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "")}`}
                title={l.label}
                className="group flex items-center gap-2 border border-white/10 hover:border-[#BAF173]/50 bg-[#0A0A0A] hover:bg-[#0E0E0E] px-3.5 py-2.5 transition-colors"
              >
                <Icon size={16} className="text-white/50 group-hover:text-[#BAF173] transition-colors" />
                <span className="font-display text-[11px] uppercase tracking-widest text-white/50 group-hover:text-white transition-colors">{l.label}</span>
              </a>
            );
          })}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-8 border-t border-white/10">
        <p className="text-xs text-white/30 uppercase tracking-widest">© {new Date().getFullYear()} REYCRO · All rights reserved</p>
        <p className="text-xs text-white/30 uppercase tracking-widest">Built to move. Wired to create.</p>
      </div>
    </div>
  </footer>
);
